import { sprWithJobIdFlow } from "@/constants/common";
import { useRegistrationProps } from "@/context/useRegistrationProps";
import { customTwMerge as twMerge } from "@/helpers/customTwMerge";
import { useMobile } from "@/hooks";
import { Button, RightArrow } from "@monsterindia/global-ui-components";
import React, { useMemo } from "react";

import Heading from "./RegistrationHeading";
import SprButtons from "./spr-buttons";

type ContentWrapperProps = {
  handleSubmit?: () => void;
  handleSkip?: () => void;
  children: React.ReactNode;
  className?: string;
  buttonStyles?: string;
  text?: string;
  subText?: string;
  isDisabled?: boolean;
  progressPercent?: number;
  headerComponent?: React.ReactNode;
};

const ContentWrapper: React.FC<ContentWrapperProps> = ({
  handleSubmit,
  className = "",
  buttonStyles = "",
  children,
  text = "",
  subText = "",
  isDisabled = false,
  headerComponent,
}) => {
  const isMobile = useMobile();

  const { isSkipabl, isLoading, getNextAction, screenType, flowType } =
    useRegistrationProps();

  const screenClassName = useMemo(() => {
    return screenType?.toLowerCase().replace(/_/g, "-");
  }, [screenType]);

  const isShowSprButtons =
    flowType === sprWithJobIdFlow &&
    screenType === "MOBILE_NUMBER_EMAIL" &&
    !isMobile;

  const shouldShowSkip =
    !isMobile &&
    isSkipabl &&
    flowType === sprWithJobIdFlow &&
    screenType !== "MOBILE_NUMBER_EMAIL" &&
    screenType !== "RESUME";

  return (
    <div
      className={twMerge(
        "flex w-full flex-col items-center justify-center px-4 pb-16 pt-6 md:px-0 md:pb-6 md:pt-0",
        flowType === sprWithJobIdFlow && "h-full pb-0 md:pb-0",
      )}
    >
      <div
        className={twMerge(
          "relative flex h-[100%] w-[100%] flex-col items-center justify-center",
          flowType === sprWithJobIdFlow
            ? "lg:!w-full"
            : "pb-10 lg:w-[85%!important]",
        )}
      >
        {/* {isSkipabl && screenType !== "LINKEDIN" && (
          <div className="static top-[76px] mb-6 flex w-full justify-end md:sticky md:mb-0">
            {isMobile ? (
              <a
                href={
                  flowType === sprWithJobIdFlow
                    ? jobDetailUrlForSprWithId
                    : "/seeker/profile"
                }
                onClick={() => {
                  if (
                    typeof window.MessageHandler?.postMessage === "function"
                  ) {
                    window.MessageHandler.postMessage(
                      JSON.stringify({
                        type: "FINAL_PAGE",
                        isFinalScreen: true,
                      }),
                    );
                  }
                }}
              >
                <Cross width="32" height="32" />
              </a>
            ) : (
              <Button
                modifier="secondary"
                className="border-border-moderate text-content-secondary"
                size="xs"
                label="Close"
                url={
                  flowType === sprWithJobIdFlow
                    ? jobDetailUrlForSprWithId
                    : "/seeker/profile"
                }
                onClick={() => {
                  if (localStorage.getItem("resumeUploaded") === "true") {
                    localStorage.removeItem("resumeUploaded");
                    localStorage.setItem("showTour", "true");
                  }
                  if (
                    typeof window.MessageHandler?.postMessage === "function"
                  ) {
                    window.MessageHandler.postMessage(
                      JSON.stringify({
                        type: "FINAL_PAGE",
                        isFinalScreen: true,
                      }),
                    );
                  }
                }}
              />
            )}
          </div>
        )} */}
        <div
          className={twMerge(
            "flex min-h-[75vh] w-full !flex-col justify-start rounded-[16px] md:rounded-[32px]",
            !isMobile && "w-[55%]",
            flowType !== sprWithJobIdFlow && "bg-white",
            flowType === sprWithJobIdFlow
              ? `w-full md:mt-0 ${isMobile ? "bg-white px-2 py-4" : ""}`
              : isMobile
                ? "px-2 py-4"
                : "px-8 py-6",
            className,
          )}
        >
          {headerComponent ? headerComponent : null}
          {subText && (
            <div className="text-content-primary mb-2">{subText}</div>
          )}
          {text && (
            <Heading
              text={text}
              className="text-content-primary md:leading-9"
            />
          )}
          {children}
          <div
            className={twMerge(
              "mt-auto w-full flex-col",
              flowType === sprWithJobIdFlow && "relative px-0",
              isShowSprButtons &&
                "bottom-0 left-0 right-0 -mx-6 w-[calc(100%+48px)]",
            )}
          >
            {isShowSprButtons ? (
              <SprButtons
                handleClick={handleSubmit}
                isDisabled={isDisabled}
                isLoading={isLoading}
              />
            ) : (
              <div
                className={twMerge(
                  "mx-auto w-full",
                  flowType === sprWithJobIdFlow ? "lg:!w-full" : "",
                )}
              >
                <div
                  className={`flex items-center p-[10px] ${isMobile ? "fixed bottom-0 left-0 right-0 z-10 w-full bg-white" : flowType === sprWithJobIdFlow ? `absolute bottom-0 left-0 right-0 z-10 w-full bg-white ${shouldShowSkip ? "justify-between" : "justify-end"}` : "justify-end"}`}
                >
                  {shouldShowSkip && (
                    <Button
                      modifier="tertiary"
                      className="text-content-secondary"
                      label="Skip"
                      onClick={getNextAction}
                    />
                  )}
                  {text && (
                    <Button
                      id={screenClassName ?? ""}
                      className={twMerge(
                        `${screenClassName ?? ""} rounded-full py-3 text-center shadow-sm`,
                        buttonStyles,
                        isMobile ? "w-full" : "w-[142px]",
                      )}
                      disabled={isDisabled || isLoading}
                      label="Continue"
                      isLoading={isLoading}
                      type="submit"
                      modifier="primary"
                      onClick={handleSubmit}
                      aria-label="submit"
                      rightIcon={
                        !isLoading && (
                          <RightArrow width={20} height={20} fill={"white"} />
                        )
                      }
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentWrapper;
